export default __webpack_public_path__ + "static/media/cake24.814c9edc.jpg";